import React from "react"
import {connect} from "react-redux";
import PropTypes from "prop-types"
import BrowseView from "../../browse/BrowseView";
import {bindActionCreators} from "redux";
import * as CustomerActions from "../../reducers/customer"
import {Row, Col, Button} from "antd"
import {NavLink} from "react-router-dom"
import CustomerTable from "./CustomerTable";
import CustomerCreationDrawer from "./create/CustomerCreationDrawer";
import CustomerUpdateDrawer from "./update/CustomerUpdateDrawer";

class CustomerView extends React.Component {

    static propTypes = {
        customers: PropTypes.array.isRequired,
        getCustomers: PropTypes.func.isRequired,
        fetchingCustomers: PropTypes.bool.isRequired,
        search: PropTypes.func.isRequired
    };

    state = {
        showCreationDrawer: false,
        showUpdateDrawer: false,
        record: {},
        selectedRowKeys: []
    };

    onSelectChange = (selectedRowKeys) => {
        this.setState({selectedRowKeys});
    };

    toggleCreationDrawer = () => this.setState(state => ({showCreationDrawer: !state.showCreationDrawer}));
    toggleUpdateDrawer = () => this.setState(state => ({showUpdateDrawer: !state.showUpdateDrawer}));
    editOnClick = (record) => this.setState({customer: record}, this.toggleUpdateDrawer)

    render() {
        const {getCustomers, customers, fetchingCustomers, search} = this.props;
        const {showCreationDrawer, showUpdateDrawer} = this.state

        const selectedId = this.state.selectedRowKeys[0];
        const disabled = selectedId === undefined;
        const titleBar = <Row>
            <Col span={4}>Customers</Col>
            <Col span={1} offset={19}>
                <NavLink to={`/customer/${selectedId}`}>
                    <Button type='primary' disabled={disabled}>Open</Button>
                </NavLink>
            </Col>
        </Row>;
        return <BrowseView
            masterTitle={titleBar}
            master={<CustomerTable dataSource={customers} onSelectChange={this.onSelectChange} loading={fetchingCustomers} toggleCreateDrawerVisibility={this.toggleCreationDrawer} onEdit={this.editOnClick}/>}
            initialQuery={getCustomers}
            searchableProps={["countryId","code","active","name","callName"]}
            drawer1={<CustomerCreationDrawer visible={showCreationDrawer} toggleVisibility={this.toggleCreationDrawer} />}
            drawer2={<CustomerUpdateDrawer visible={showUpdateDrawer} toggleVisibility={this.toggleUpdateDrawer} customer={this.state.customer} />}
            searchLogic={search}
            loading={fetchingCustomers}
        />
    }
}

const mapStateToProps = state => ({
    customers: state.customer.customers,
    fetchingCustomers: state.customer.fetchingCustomers
});

const mapDispatchToProps = dispatch => ({
    getCustomers: bindActionCreators(CustomerActions, dispatch).getCustomers,
    search: bindActionCreators(CustomerActions, dispatch).search
});

export default connect(mapStateToProps, mapDispatchToProps)(CustomerView)


// WEBPACK FOOTER //
// ./src/js/browse/customer/CustomerView.js